jQuery(document).ready(function ($) {
    $('.clickable-menu .vc_cta3-shape-square').click(function (e) {
        e.preventDefault();
        $(this).parent().siblings('.vc_inner').toggle();
        $(this).toggleClass('active')
    })

    $('.clickable-menu .wpb_single_image').click(function (e) {
        e.preventDefault();
        $(this).siblings('div').slideToggle();
        $(this).toggleClass('active')
    })
})